import axios from 'axios'

// Constants
import {
  USER_LIST_REQUEST,
  USER_LIST_SUCCESS,
  USER_LIST_FAIL,
  ADMIN_GET_USER_REQUEST,
  ADMIN_GET_USER_SUCCESS,
  ADMIN_GET_USER_FAIL,
  ADMIN_UPDATE_USER_REQUEST,
  ADMIN_UPDATE_USER_SUCCESS,
  ADMIN_UPDATE_USER_FAIL,
  ADMIN_DELETE_USER_REQUEST,
  ADMIN_DELETE_USER_SUCCESS,
  ADMIN_DELETE_USER_FAIL
} from '../constants/adminConstants.js'

import { API_URL } from '../apiUrl.js'
import { authHeader } from '../utils/authHeader.js'

// Get all users
export const listUsers = () => async (dispatch, getState) => {
  try {
    dispatch({ type: USER_LIST_REQUEST })

    // Get user info
    const {
      userLogin: { userInfo }
    } = getState()

    // Set header
    const config = { headers: authHeader(userInfo) }

    // Get data
    if (userInfo.isAdmin) {
      const { data } = await axios.get(`${API_URL}/admin/getallusers`, config)
      dispatch({ type: USER_LIST_SUCCESS, payload: data })
    }
  } catch (error) {
    dispatch({
      type: USER_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
    })
  }
}

// Get user by id
export const getUserDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ADMIN_GET_USER_REQUEST
    })

    const {
      userLogin: { userInfo }
    } = getState()

    const config = { headers: authHeader(userInfo) }

    const { data } = await axios.get(`${API_URL}/admin/user/${id}`, config)

    dispatch({
      type: ADMIN_GET_USER_SUCCESS,
      payload: data
    })
  } catch (e) {
    dispatch({
      type: ADMIN_GET_USER_FAIL,
      payload:
        e.response && e.response.data.message
          ? e.response.data.message
          : e.message
    })
  }
}

// Update user
export const updateUser = (user) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ADMIN_UPDATE_USER_REQUEST
    })

    const {
      userLogin: { userInfo }
    } = getState()

    const config = { headers: authHeader(userInfo) }

    const { data } = await axios.put(
      `${API_URL}/admin/modifyuser`,
      user,
      config
    )

    dispatch({
      type: ADMIN_UPDATE_USER_SUCCESS,
      payload: data
    })
  } catch (e) {
    dispatch({
      type: ADMIN_UPDATE_USER_FAIL,
      payload:
        e.response && e.response.data.message
          ? e.response.data.message
          : e.message
    })
  }
}

// Delete user
export const deleteUser = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ADMIN_DELETE_USER_REQUEST
    })

    const {
      userLogin: { userInfo }
    } = getState()

    const config = { headers: authHeader(userInfo) }

    await axios.delete(`${API_URL}/admin/deleteuser/${id}`, config)

    dispatch({
      type: ADMIN_DELETE_USER_SUCCESS
    })
  } catch (e) {
    dispatch({
      type: ADMIN_DELETE_USER_FAIL,
      payload:
        e.response && e.response.data.message
          ? e.response.data.message
          : e.message
    })
  }
}
